<div class="toolbar-container">
  <ng-container *ngFor="let tool of toolbar | keyvalue:keepOriginalOrder">
    <div [attr.data-cy]="'tool-id-' + tool.key"
         *ngIf="!tool.value.hidden"
         class="toolContainer">
      <ng-container
                    *ngTemplateOutlet="_toolDefsByName.get(tool.key)?.template; context: {$implicit: tool.value}"></ng-container>
    </div>
  </ng-container>
</div>